// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"8f3cf65c","243":"88541244","311":"86a000ef","444":"de7f348d","457":"d1dc9d46","553":"d1683f35","742":"45effeed","888":"d94d3ce2","965":"bd73ddbe"}[chunkId] + ".chunk.js";
};